import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { LucideAngularModule } from "lucide-angular";
import { RemoveMemberDialogComponent } from "./remove-member-dialog.component";

@NgModule({
  declarations: [RemoveMemberDialogComponent],
  imports: [CommonModule, TranslateModule, LucideAngularModule],
})
export class RemoveMemberDialogModule {}
